import {actions, ActionType} from './action';
import {ITorosInfo} from '../../../common/type';
import {
  createBasicReducerHandlers,
  createReducer,
  ReducerActionHelper,
} from '../../../common/util/redux';
import {IMainItem} from '../../common/type';
import {
  IRecommendContentCard,
  ISpecialCard,
  ISpecialContent,
  IWaitfree,
  IRanking,
} from '../type';

export interface IStateMain {
  recommendContentCards: {
    items: IRecommendContentCard[];
    torosInfo?: ITorosInfo;
  };
  specialList: ISpecialCard[];
  specialContent: ISpecialContent;
  prevSpecialId?: number;
  waitfrees: IWaitfree;
  hotList: IMainItem[];
  todayFreeSeries?: IMainItem;
  wufPlus?: IMainItem;
  ranking: IRanking;
}

const INITIAL_STATE: IStateMain = {
  recommendContentCards: {items: []},
  specialList: [],
  specialContent: {
    id: 0,
    sid: '',
    contentId: 0,
    pages: [],
  },
  waitfrees: {
    contents: [],
    waitfreeInfo: {
      hours: 0,
      episodeCount: 0,
    },
  },
  hotList: [],
  ranking: {
    tabs: [],
    talkBoards: [],
  },
};

export default createReducer<IStateMain, ReducerActionHelper<typeof actions>>(
  INITIAL_STATE,
  {
    ...createBasicReducerHandlers({
      setValueActionType: ActionType.SetValue,
      setPropertyValuesActionType: ActionType.SetPropertyValues,
    }),
    [ActionType.SetMainContents]: (state, action) => {
      const {recommends, specials, waitfrees} = action.payload;
      state.recommendContentCards = recommends;
      state.specialList = specials;
      state.waitfrees = waitfrees;
    },
    [ActionType.SetRankingTabContents]: (state, action) => {
      const {
        tag,
        adminSectionList,
        isRankingInProgress,
        rankingSectionTitle,
        rankingList,
      } = action.payload;
      const tabState = state.ranking.tabs.find(item => item.tag === tag);
      if (tabState) {
        tabState.adminSectionList = adminSectionList;
        tabState.isRankingInProgress = isRankingInProgress;
        tabState.rankingSectionTitle = rankingSectionTitle;
        tabState.rankingList = rankingList;
      }
    },
  }
);
